const parentTypes = {
  docsComment: 'docsComment',
  documents: 'documents',
  requests: 'requests',
};

export default parentTypes;
